<template>
  <div class="profile-container">
    <div class="profile-content">
      <div class="profile-section">
        <h2>Personal Information</h2>
        <div v-if="loading" class="loading-state">
          Loading profile information...
        </div>
        <div v-else-if="error" class="error-state">
          {{ error }}
        </div>
        <div v-else class="info-grid">
          <div class="info-item">
            <label>Full Name</label>
            <p>{{ userProfile.full_name }}</p>
          </div>
          <div class="info-item">
            <label>Email</label>
            <p>{{ userProfile.email }}</p>
          </div>
          <div class="info-item">
            <label>Phone</label>
            <p>{{ userProfile.phone }}</p>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import {request} from "@/Util/Request";
import axios from "@/axios";

export default {
  name: 'UserProfile',
  data() {
    return {
      userProfile: {
        full_name: '',
        email: '',
        phone: '',
        location: ''
      },
      settings: {
        emailNotifications: false,
        twoFactorAuth: false
      },
      loading: true,
      error: null
    }
  },
  methods: {
    async fetchProfileData() {
      try {
        this.loading = true
        this.error = null
        const response = await axios.get('/auth/profile');
        const data = response.data.data;
        this.userProfile = {
          full_name: data.full_name || '',
          email: data.email || '',
          phone: data.phone || '',
        }
        this.settings = {
          emailNotifications: data.settings?.emailNotifications || false,
          twoFactorAuth: data.settings?.twoFactorAuth || false
        }
      } catch (error) {
        console.error('Error fetching profile:', error)
        this.error = 'Failed to load profile information. Please try again later.'
      } finally {
        this.loading = false
      }
    },
    async updateSettings() {
      try {
        const response = await request({
          method: "put",
          url: `/auth/profile/settings`,
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('admin_token')}`
          },
          data: this.settings
        });

        if (!response.ok) {
          throw new Error('Failed to update settings')
        }

        // Show success message or handle response
        const data = response.data
        console.log('Settings updated successfully:', data)
      } catch (error) {
        console.error('Error updating settings:', error)
        // Revert settings if update fails
        await this.fetchProfileData()
      }
    }
  },
  mounted() {
    this.fetchProfileData()
  }
}
</script>

<style scoped>
.profile-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.profile-content {
  display: grid;
  gap: 30px;
}

.profile-section {
  background: white;
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.profile-section h2 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 20px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.info-item label {
  display: block;
  color: #666;
  margin-bottom: 5px;
  font-size: 14px;
}

.info-item p {
  margin: 0;
  color: #333;
  font-size: 16px;
}

.settings-grid {
  display: grid;
  gap: 20px;
}

.setting-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #eee;
}

.setting-item:last-child {
  border-bottom: none;
}

.setting-info h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.setting-info p {
  margin: 5px 0 0 0;
  color: #666;
  font-size: 14px;
}

/* Switch styling */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
}

input:checked + .slider {
  background-color: #4CAF50;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

@media (max-width: 768px) {
  .info-grid {
    grid-template-columns: 1fr;
  }
}

.loading-state,
.error-state {
  text-align: center;
  padding: 20px;
  color: #666;
}

.error-state {
  color: #dc3545;
}
</style>
